module.exports = __webpack_public_path__ + "static/media/chat (2).79236671.svg";